import { ReactNode } from "react";

interface IDefaultSlide {
  title: string;
  children?: ReactNode;
}

export default function DefaultSlide({ title, children }: IDefaultSlide) {
  return (
    <section className="ms dark" data-background-color="#333">
      <header>
        <h2>{title}</h2>
      </header>
      <div className="slide-body">
        <div className="col">
          {children}
        </div>
      </div>
    </section>
  );
}
